module.exports = __webpack_public_path__ + "static/media/3cardsequence.3fa58f93.png";